import {useEffect} from 'react';
import {View} from 'react-native';
import PropTypes from 'prop-types';
import moment from 'moment';

import sy from '~/styles';
import {Text, ServiceRequestStatusIcon} from '~/components/controls';
import {service_request as serviceRequestApi} from '~/api/private';
import {STATUS_DESCRIPTIONS} from '~/types/statuses';

import TextsmsIcon from '~/images/md-icons/textsms/materialicons/24px.svg';
import EmailIcon from '~/images/md-icons/email/materialicons/24px.svg';
import UpdateIcon from '~/images/md-icons/update/materialicons/24px.svg';

const Activity = ({
  request_id,
  activity_id,
  attributes,
  status,
  display_timestamp,
  is_last_activity,
}) => {
  useEffect(() => {
    serviceRequestApi.activity_read(request_id, activity_id);
  }, []);

  const iconColor = is_last_activity ? '#4a4a49' : '#828282';
  const messageStyle = is_last_activity ? null : sy['text-lightgray'];

  if (attributes?.type === 'SMS') {
    return (
      <View
        style={[
          sy['rounded-lg'],
          sy['bg-white'],
          sy['py-2'],
          sy['px-4'],
          sy['flex-row'],
          sy['items-center'],
          sy['gap-4'],
        ]}>
        <TextsmsIcon fill={iconColor} width={18} height={18} />
        <View
          style={[
            sy['flex-1'],
            sy['flex-row'],
            sy['justify-between'],
            {paddingRight: 10},
          ]}>
          <Text style={[sy.smallMedium, messageStyle]}>
            {status === 'SentFailed'
              ? 'SMS verzenden mislukt'
              : 'SMS verzonden'}
          </Text>
          <Text style={[sy.small]}>{display_timestamp.format('H:mm')}</Text>
        </View>
      </View>
    );
  } else if (attributes?.type === 'Email') {
    return (
      <View
        style={[
          sy['rounded-lg'],
          sy['bg-white'],
          sy['py-2'],
          sy['px-4'],
          sy['flex-row'],
          sy['items-center'],
          sy['gap-4'],
        ]}>
        <EmailIcon fill={iconColor} width={18} height={18} />
        <View
          style={[
            sy['flex-1'],
            sy['flex-row'],
            sy['justify-between'],
            {paddingRight: 10},
          ]}>
          <Text style={[sy.smallMedium, messageStyle]}>E-mail verzonden</Text>
          <Text style={[sy.small]}>{display_timestamp.format('H:mm')}</Text>
        </View>
      </View>
    );
  }

  if (
    [
      'DATE_CHANGED',
      'TIME_CHANGED',
      'EXPECTED_COMPLETION_DATE_CHANGED',
    ].includes(status)
  ) {
    let changeContent;
    if (status === 'EXPECTED_COMPLETION_DATE_CHANGED') {
      changeContent = (
        <>
          {`Gereed (verwacht): ${moment(
            attributes.expected_completion_date,
          ).format('D MMM')}`}
          &nbsp;(
          <Text
            style={[sy.smallMedium, sy['text-lightgray'], sy['line-through']]}>
            {moment(attributes.previous).format('D MMM')}
          </Text>
          )
        </>
      );
    } else if (status === 'DATE_CHANGED') {
      changeContent = (
        <>
          {`Datum afspraak: ${moment(attributes.date).format('D MMM')}`}
          &nbsp;(
          <Text
            style={[sy.smallMedium, sy['text-lightgray'], sy['line-through']]}>
            {moment(attributes.previous).format('D MMM')}
          </Text>
          )
        </>
      );
    } else {
      changeContent = (
        <>
          {`Tijd afspraak: ${attributes.time}`}
          &nbsp;(
          <Text
            style={[sy.smallMedium, sy['text-lightgray'], sy['line-through']]}>
            {attributes.previous}
          </Text>
          )
        </>
      );
    }

    return (
      <View
        style={[
          sy['rounded-lg'],
          sy['bg-white'],
          sy['py-2'],
          sy['px-4'],
          sy['flex-row'],
          sy['items-center'],
          sy['gap-4'],
        ]}>
        <UpdateIcon fill="#828282" width={18} height={18} />
        <View
          style={[
            sy['flex-1'],
            sy['flex-row'],
            sy['justify-between'],
            {paddingRight: 10},
          ]}>
          <Text style={[sy.smallMedium, sy['text-lightgray']]}>
            {changeContent}
          </Text>
          <Text style={[sy.small]}>{display_timestamp.format('H:mm')}</Text>
        </View>
      </View>
    );
  }

  return (
    <View
      style={[
        sy['rounded-lg'],
        sy['bg-white'],
        sy['py-2'],
        sy['px-4'],
        sy['flex-row'],
        sy['items-center'],
        sy['gap-4'],
      ]}>
      <ServiceRequestStatusIcon
        status={status}
        fill={is_last_activity ? null : '#828282'}
        iconProps={{
          width: 18,
          height: 18,
        }}
      />
      <View
        style={[
          sy['flex-1'],
          sy['flex-row'],
          sy['justify-between'],
          {paddingRight: 10},
        ]}>
        <Text
          style={[sy.smallMedium, !is_last_activity && sy['text-lightgray']]}>
          {STATUS_DESCRIPTIONS[status] ?? status}
        </Text>
        <Text style={[sy.small]}>{display_timestamp.format('H:mm')}</Text>
      </View>
    </View>
  );
};
Activity.propTypes = {
  request_id: PropTypes.any,
  activity_id: PropTypes.any,
  attributes: PropTypes.any,
  status: PropTypes.any,
  display_timestamp: PropTypes.any,
  is_last_activity: PropTypes.any,
};

export default Activity;
